import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 16 12">
        <path d="M12 6a.996.996 0 0 1-.293.7069l-5 5a.9997.9997 0 0 1-1.414 0 .9997.9997 0 0 1 0-1.4141L9.5875 6 5.2937 1.7062a.9996.9996 0 0 1 0-1.414.9996.9996 0 0 1 1.4141 0l5 5A.9971.9971 0 0 1 12 6Z" />
    </SvgIcon>
);
